import type { Survey, SurveyResults } from 'app/common/types/surveys'
import ThumbUp from 'app/images/surveys/thumb-up.svg'
import ThumbDown from 'app/images/surveys/thumb-down.svg'

import styles from './SurveyDetailsSummary.module.scss'

export const dateFormat = 'DD.MM.YYYY'

type Props = {
  survey: Survey
  totals?: SurveyResults
}

export const SurveyDetailsSummary = ({
  survey,
  totals,
}: Props) => (
  <div className={styles.root}>
    <div>
      <div className={styles.muted}>
        {survey.cities && survey.cities.count > 1
          ? `Населенных пунктов: ${survey.cities.count}`
          : survey.scope.cityName || 'Все населенные пункты'}
      </div>
      <div className={styles.institution}>
        {survey.schools && survey.schools.count > 1
          ? `Заведений: ${survey.schools.count}`
          : survey.scope.schoolName || 'Все заведения'}
      </div>
      <div>{`с ${survey.startsOn?.getStringFormatted(dateFormat)} по ${survey.endsOn?.getStringFormatted(dateFormat)}`}</div>
    </div>
    <div className={styles.totals}>
      <div>{`Всего: ${(totals?.total || 0).toLocaleString('ru-RU')}`}</div>
      <span className={styles.vote}>
        <ThumbUp aria-label="Положительные ответы" />
        {(totals?.positive || 0).toLocaleString('ru-RU')}
      </span>
      <span className={styles.vote}>
        <ThumbDown aria-label="Отрицательные ответы" />
        {(totals?.negative || 0).toLocaleString('ru-RU')}
      </span>
    </div>
  </div>
)
